import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../shared/services/auth.service';
import { DateTime } from 'luxon';
import { AppConfigService } from '@/app/core/services/app-config.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router,
    private appConfigService: AppConfigService
  ) {}

  canActivate(): boolean {
    const isAuthenticated = this.auth.isAuthenticated();
    const tokenExpiration = this.auth.getTokenExpirationDateTime();
    if (isAuthenticated) {
      if (tokenExpiration > DateTime.now()) {
        // Ensure authenticated configurations are initialized for direct navigation to protected routes
        this.appConfigService.initializeAuthenticatedConfigurations().catch(() => {
          // Error handling is done in the service itself
        });
        return true;
      } else {
        this.router.navigateByUrl('/auth/login');
      }
    }

    this.router.navigateByUrl('/auth/login');
    localStorage.clear();
    return false;
  }
}
